<template>
  <div class="scatter-wrap w-100" :data-key="uuid">

    <p class="content-pad-x centered-wrap position-relative mb-neg-6 graph-copy black text-left" v-html="data.sub"></p>

    <scatter-vect :active="active" :ind-override="indOverride" :points="data.points" ref="graph"/>

  </div>
</template>

<script>
  import GraphMixin from '@/components/report/mixins/GraphMixin'
  import ContentMixin from '@/components/report/mixins/ContentMixin'
  import ScatterVect from '@/components/svg/ScatterVect'

  export default {
    name: 'Scatter',
    mixins: [ ContentMixin, GraphMixin ],
    mounted () {
      this.wpTarget = this.$refs.graph
    },
    components: { ScatterVect }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  .scatter-sub {
    font-size     : rem(22);
    line-height   : 1.5454;
    margin-bottom : -10%;
  }

  .scatter-wrap {
    p {
      @include screen-md-lg-xl {
        padding-left  : 0;
        padding-right : 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/Scatter.vue